// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Create_job_input {
  height: 30px !important;
  font-size: 12px !important;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.25) !important;
  border-radius: 5px;
}

.create_lable {
  font-size: 12px !important;
}

.CreateJob_dropDown {
  height: 32px;
  border-radius: 5px;
  padding-inline: 1%;
  background-color: white;
  margin-left: 1px;
  margin-right: 2%;
  margin-block: 1%;
  width: 100%;
}

::ng-deep.CreateJob_dropDown .mat-form-field-infix {
  border: 0 !important;
  height: 33px !important;
  font-size: 11px;
  padding-top: 10% !important;
  line-height: 17px !important;
}

::ng-deep.CreateJob_dropDown .mat-form-field-appearance-outline .mat-form-field-wrapper {
  padding: 1%;
  margin: 1%;
}

::ng-deep.CreateJob_dropDown .mat-form-field-label-wrapper {
  top: -1px !important;
}

.CreateJob_default {
  height: 32px;
  border-radius: 5px;
  padding-inline: 1%;
  position: relative;
  top: 1%;
  background-color: white;
  margin-left: 1px;
  margin-right: 2%;
  margin-block: 1%;
}

::ng-deep.CreateJob_default .mat-form-field-infix {
  border: 0 !important;
  height: 33px !important;
  font-size: 11px;
  padding-top: 8% !important;
  line-height: 19px !important;
}

::ng-deep.CreateJob_default .mat-form-field-appearance-outline .mat-form-field-wrapper {
  padding: 1%;
  margin: 1%;
}

::ng-deep.CreateJob_default .mat-form-field-label-wrapper {
  top: -24% !important;
}

._oldNotes_style {
  background-color: #e9ecef;
  height: 72px;
  font-size: 12px !important;
  overflow-y: auto;
  overflow-x: hidden;
}`, "",{"version":3,"sources":["webpack://./src/app/createjob/createjob.component.scss","webpack://./src/variables.scss"],"names":[],"mappings":"AAEA;EACE,uBCCW;EDAX,0BCHS;EDIT,oDAAA;EACA,kBAAA;AADF;;AAIA;EACE,0BCTS;ADQX;;AAKA;EACE,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,uBAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,WAAA;AAFF;;AAKA;EACE,oBAAA;EACA,uBAAA;EACA,eAAA;EACA,2BAAA;EACA,4BAAA;AAFF;;AAKA;EACE,WAAA;EACA,UAAA;AAFF;;AAKA;EACE,oBAAA;AAFF;;AAKA;EACE,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,OAAA;EACA,uBAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;AAFF;;AAKA;EACE,oBAAA;EACA,uBAAA;EACA,eAAA;EACA,0BAAA;EACA,4BAAA;AAFF;;AAKA;EACE,WAAA;EACA,UAAA;AAFF;;AAKA;EACE,oBAAA;AAFF;;AAKA;EACE,yBAAA;EACA,YAAA;EACA,0BCzES;ED0ET,gBAAA;EACA,kBAAA;AAFF","sourcesContent":["@import '../../variables.scss';\r\n\r\n.Create_job_input {\r\n  height: $inputHeight;\r\n  font-size: $fontsize;\r\n  box-shadow: 0 2px 5px rgb(0 0 0 / 25%) !important;\r\n  border-radius: 5px;\r\n}\r\n\r\n.create_lable {\r\n  font-size: $fontsize\r\n}\r\n\r\n\r\n.CreateJob_dropDown {\r\n  height: 32px;\r\n  border-radius: 5px;\r\n  padding-inline: 1%;\r\n  background-color: white;\r\n  margin-left: 1px;\r\n  margin-right: 2%;\r\n  margin-block: 1%;\r\n  width: 100%;\r\n}\r\n\r\n::ng-deep.CreateJob_dropDown .mat-form-field-infix {\r\n  border: 0 !important;\r\n  height: 33px !important;\r\n  font-size: 11px;\r\n  padding-top: 10% !important;\r\n  line-height: 17px !important;\r\n}\r\n\r\n::ng-deep.CreateJob_dropDown .mat-form-field-appearance-outline .mat-form-field-wrapper {\r\n  padding: 1%;\r\n  margin: 1%;\r\n}\r\n\r\n::ng-deep.CreateJob_dropDown .mat-form-field-label-wrapper {\r\n  top: -1px !important;\r\n}\r\n\r\n.CreateJob_default {\r\n  height: 32px;\r\n  border-radius: 5px;\r\n  padding-inline: 1%;\r\n  position: relative;\r\n  top: 1%;\r\n  background-color: white;\r\n  margin-left: 1px;\r\n  margin-right: 2%;\r\n  margin-block: 1%;\r\n}\r\n\r\n::ng-deep.CreateJob_default .mat-form-field-infix {\r\n  border: 0 !important;\r\n  height: 33px !important;\r\n  font-size: 11px;\r\n  padding-top: 8% !important;\r\n  line-height: 19px !important;\r\n}\r\n\r\n::ng-deep.CreateJob_default .mat-form-field-appearance-outline .mat-form-field-wrapper {\r\n  padding: 1%;\r\n  margin: 1%;\r\n}\r\n\r\n::ng-deep.CreateJob_default .mat-form-field-label-wrapper {\r\n  top: -24% !important;\r\n}\r\n\r\n._oldNotes_style{\r\n  background-color: #e9ecef;\r\n  height: 72px;\r\n  font-size: $fontsize;\r\n  overflow-y: auto;\r\n  overflow-x: hidden;\r\n}\r\n\r\n","$btn-color: #17a0b4 !important;\r\n$fontsize: 12px !important;\r\n$btntextcolor: white !important;\r\n$btnHeight: 28px !important;\r\n$inputHeight:30px !important;\r\n$inputfontsize:11px !important;\r\n$primary:#004bff;\r\n// $modalHeaderTitleFont: ;\r\n@mixin modalheaderTtext {\r\n  font-size: 14px;\r\n  font-weight: 600;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
